// extracted by mini-css-extract-plugin
export default {"container":"order-sent_container__uUcAN"};